import React from 'react';
import { NavLink } from 'react-router-dom';

const ActionBar = ({
    addLink,
    addLabel,
    searchTerm,
    onSearchChange,
    onFilterClick,
    showFilter,
    placeholder = "Search...",
    backButton,
    children
}) => {
    return (
        <div className="action-bar">
            <div className="search-filter-group">
                {backButton}
                <div className="search-box">
                    <i className="mdi mdi-magnify"></i>
                    <input
                        type="text"
                        className="form-control"
                        onChange={onSearchChange}
                        placeholder={placeholder}
                        value={searchTerm}
                    />
                </div>
            </div>

            <div className="action-bar-right">
                {addLink && (
                    <NavLink to={addLink} className="btn-add-manager">
                        <i className="mdi mdi-plus" />
                        {addLabel}
                    </NavLink>
                )}
                {showFilter &&
                    <button
                        className="btn btn-filter"
                        onClick={onFilterClick}
                        title="Filter"
                    >
                        <i className="mdi mdi-filter-outline"></i>
                    </button>
                }
            </div>

            {children}
        </div>
    );
};

export default ActionBar;
